import { post } from "../../service/api";

const AddUserPin = async (userId, pin) => {
    try {
        const response = await post(`/user/${userId}/pin`, { pin });
        return response;
    } catch (error) {
        console.error('Error SetUserPin:', error);
        throw error;
    }
};

export default AddUserPin;